export { default } from './TimelineSeparator';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/lab/esm/TimelineSeparator/index.js
// module id = 1403
// module chunks = 121